import { QueryCache, QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { scopedQueryKeyHashFn } from "./lib/query-scope";
import { PyngLoader } from "./components/pyng-loader";

// Protected server functions throw a raw 401 Response when the session is
// missing (sign-out, expired token). Unhandled, React renders it as
// "Error: [object Response]" over a blank screen — send people to /login.
function isUnauthorized(error: unknown): boolean {
  return error instanceof Response && (error.status === 401 || error.status === 403);
}

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        queryKeyHashFn: scopedQueryKeyHashFn,
        retry: (count, error) => !isUnauthorized(error) && count < 2,
      },
    },
    queryCache: new QueryCache({
      onError: (error) => {
        if (!isUnauthorized(error)) return;
        if (typeof window === "undefined") return;
        if (window.location.pathname === "/login") return;
        window.location.replace("/login");
      },
    }),
  });


  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: () => <PyngLoader fullscreen />,
    defaultPendingMs: 400,
    defaultPendingMinMs: 350,
  });

  return router;
};
